import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesPushService {
  readonly VAPID_PUBLIC_KEY =
    'BMqLlQRrfERhM2nlGAZiyc5SKalTzR_TXRhxa7Rp563Gi8eYCbOwhcUHJMki5u3bXYJYcwEU9-I3c7xkSiAihV8';

  constructor(private http: HttpClient) {}

  agregarSubscriptorPush(sub: PushSubscription): any {
    return this.http.post(environment.baseUrl + '/subscriptor-push/', sub);
  }
  borrarSubscriptorPush(sub: PushSubscription): any {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: sub
    };
    return this.http.delete(
      environment.baseUrl + '/subscriptor-push/',
      httpOptions
    );
  }
}
